export const sendNotification = async (massage, to) => {
  console.log(to);
  const Header = new Headers();
  Header.set("content-Type", "application/json");
  Header.set(
    "Authorization",
    "key=AAAAAWjwrNA:APA91bFPBM4cT2nwQGtUzEXB7ze5TXMdixRVAFozrRiCA8ZG3MkM-AgHoHRgHKrKe6Cn6oWhRRshACA_fHKkOS-WOA6YhmeepAoPpPdAqpUP05Lxz1ZLswEFJXS0BdLYrKy5DSGV8-WR"
  );
  await fetch("https://fcm.googleapis.com/fcm/send", {
    method: "POST",

    headers: Header,
    body: JSON.stringify({
      to: to,
      notification: {
        body: massage,
        title: "Auto Info",
        sound: "default",
      },
    }),
  }).then((response) => console.log(response));
  return true;
};
